<template>
  <Modal header-tag="h3" :show="show" @close="$emit('close-modal')">
    <template #header>
      <VisibleText>Machine Learning Snapshots </VisibleText>
    </template>

    <div>
      <!-- TODO nice to have -->
      <!-- <div class="filter-row">
          <label>
            <input type="checkbox" v-model="filterMineOnly" />
            Show only my snapshots
          </label>
      </div> -->

      <div class="snapshot-list">
        <div v-for="snap in filteredSnapshots" :key="snap._id" class="snapshot-item">
          <div class="snapshot-summary">
            <span> <strong>Created on:</strong> {{ formatDateTime(snap.created_on, 'en') }} </span>

            <div style="margin-bottom: 1rem">
              <strong>Created by:</strong> {{ getSnapshotOwner(snap.created_by) }}
            </div>

            <div class="snapshot-section">
              <div class="snapshot-title">A human accepted:</div>
              <ul>
                <li>
                  <span class="signal positive">✓</span>
                  <span>Keyword-only matches</span>
                  <strong>{{ snap.keyword_matches }}</strong>
                </li>

                <li>
                  <span class="signal positive">✓</span>
                  <span>Machine Learning notes</span>
                  <strong>{{ snap.ml_added_notes }}</strong>
                </li>

                <li>
                  <span class="signal negative">✕</span>
                  <span>ML-blocked keyword matches</span>
                  <strong>{{ snap.ml_blocked_keywords }}</strong>
                </li>

                <li>
                  <span class="signal negative">✕</span>
                  <span>Left unmatched</span>
                  <strong>{{ snap.no_matches }}</strong>
                </li>
              </ul>
            </div>

            <div class="snapshot-section">
              <div class="snapshot-title">A human took these actions:</div>
              <ul>
                <li>
                  <span class="signal positive">✓</span>
                  <span>Added notes</span>
                  <strong>{{ snap.human_notes }}</strong>
                </li>

                <li>
                  <span class="signal negative">✕</span>
                  <span>Dropped / blocked keyword matches</span>
                  <strong>{{ snap.human_blocked_keywords }}</strong>
                </li>

                <li>
                  <span class="signal negative">✕</span>
                  <span>Dropped / blocked ML notes</span>
                  <strong>{{ snap.human_dropped_ml_notes }}</strong>
                </li>
              </ul>
            </div>

            <div class="snapshot-footer">
              <span
                >Out of <strong>{{ snap.total_labeled }}</strong> responses</span
              >
              <span>{{ snap.positives }} positives</span>
              <span>{{ snap.negatives }} negatives</span>
              <span v-if="snap.overridden" class="snapshot-note">
                This snapshot replaced the previous one.
              </span>
            </div>

            <div style="display: flex; flex-direction: row">
              <button
                class="table__toolbar-btn snapshot-delete"
                style="font-size: 0.8rem"
                @click="dropSnapshot(snap)"
              >
                <SvgIconDecorative icon="deleteIcon" id="clean-icon" />
                Delete Snapshot
              </button>
              <button
                v-if="hasMetadata"
                class="table__toolbar-btn snapshot-delete"
                style="font-size: 0.8rem; padding-left: 0.25rem"
                @click="getMetadata(snap)"
              >
                <SvgIconDecorative icon="search" id="clean-icon" />
                Meta data
              </button>
            </div>
          </div>
        </div>
      </div>
      <button
        v-if="hasMetadata"
        class="table__toolbar-btn snapshot-delete"
        style="margin-top: 1rem; font-size: 0.8rem"
        @click="getAllMetadata"
      >
        <SvgIconDecorative icon="search" id="clean-icon" />
        All meta data
      </button>
    </div>
    <Modal header-tag="h3" :show="showMetadata" @close="closeMetadata">
      <template #header>
        <VisibleText>Snapshot Metadata</VisibleText>
      </template>

      <div class="metadata-container">
        <pre class="metadata-pretty">{{ JSON.stringify(activeMetadata, null, 2) }}</pre>
      </div>
    </Modal>
    <Modal header-tag="h3" :show="showAllMetadata" @close="closeAllMetadata">
      <template #header>
        <VisibleText>All Snapshot Metadata</VisibleText>
      </template>

      <div class="metadata-container">
        <pre class="metadata-pretty">{{ JSON.stringify(allMetadataContent, null, 2) }}</pre>
      </div>
    </Modal>
  </Modal>
</template>

<script>
import Modal from '@/components/UI/Modal.vue';
import moment from 'moment';
import SvgIconDecorative from '@/components/UI/Svg/SvgIconDecorative.vue';
import customTopicModelService from '@/services/customTopicModelService.js';

export default {
  name: 'AllSnapshots',
  props: {
    show: {
      default: () => false,
      type: Boolean,
    },
    filteredSnapshots: {
      default: () => [],
      type: Array,
    },
    teamMembers: {
      default: () => [],
      type: Array,
    },
    profile: {
      default: () => {},
      type: Object,
    },
    model_theme_id: {
      default: () => '',
      type: String,
    },
    hasMetadata: {
      default: () => false,
      type: Boolean,
    },
  },
  components: {
    Modal,
    SvgIconDecorative,
  },
  data() {
    return {
      filterMineOnly: false,
      CUSTOM_TOPIC_MODEL_SERVICE: new customTopicModelService(this.$pigeonline),
      showMetadata: false,
      activeMetadata: null,
      showAllMetadata: false,
      allMetadataContent: null,
    };
  },
  methods: {
    formatDateTime: (value, language) => {
      let currentLang = '';
      if (language) {
        currentLang = language;
      }
      if (value) {
        if (currentLang === 'fr') {
          return moment(value).locale('fr').format('MMMM D, YYYY hh:mm A').toString();
        } else {
          return moment(value).format('MMMM D, YYYY hh:mm A').toString();
        }
      }
    },
    dropSnapshot(snap) {
      this.$emit('dropSnapshot', snap);
    },
    getSnapshotOwner(owner) {
      const found_team_member = this.teamMembers.filter((member) => member.id == owner);
      if (found_team_member.length) {
        return found_team_member[0].email;
      }
      if (this.profile && this.profile.django_ref_id == owner) {
        return 'Your snapshot';
      }
    },
    async getMetadata(snap) {
      const id = snap._id?.$oid || snap._id;

      const payload = { snapshot_id: id };
      const result = await this.CUSTOM_TOPIC_MODEL_SERVICE.getSnapshotMetadata(payload);

      if (result) {
        this.activeMetadata = result;
        this.showMetadata = true;
      }
    },

    closeMetadata() {
      this.showMetadata = false;
      this.activeMetadata = null;
    },
    async getAllMetadata() {
      if (!this.model_theme_id) return;

      const payload = { model_theme_id: this.model_theme_id };
      const result = await this.CUSTOM_TOPIC_MODEL_SERVICE.getAllSnapshotMetadata(payload);

      if (result) {
        this.allMetadataContent = result;
        this.showAllMetadata = true;
      }
    },
    closeAllMetadata() {
      this.showAllMetadata = false;
      this.allMetadataContent = null;
    },
  },
};
</script>

<style scoped>
/* Make the list a horizontal flex container that wraps */
.snapshot-list {
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
  align-items: flex-start;
}

/* Each snapshot card becomes a flex item */
.snapshot-item {
  flex: 1 1 300px; /* grows, shrinks, minimum width */
  max-width: 360px; /* prevents cards from getting too wide */
}

/* Snapshot card styling */
.snapshot-summary {
  background: #ffffff;
  border-radius: 8px;
  padding: 16px 18px;
  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.08);
  color: #0f172a;
  display: flex;
  flex-direction: column;
  height: 26rem;
  position: relative;
}

/* Optional: make delete button sit at the bottom of the card */
.snapshot-summary {
  display: flex;
  flex-direction: column;
}

.snapshot-delete {
  margin-top: auto; /* pushes it to the bottom */
}

/* Existing styles preserved */
.snapshot-date {
  font-size: 0.9rem;
  margin-bottom: 4px;
}

.snapshot-section {
  margin-bottom: 14px;
}

.snapshot-title {
  font-size: 0.9rem;
  font-weight: 600;
  margin-bottom: 6px;
}

.snapshot-section ul {
  list-style: none;
  padding: 0;
  margin: 0;
}

/* Ensure list items align nicely with the new icon */
.snapshot-section li {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 6px;
}

.snapshot-section li span:nth-child(2) {
  flex: 1; /* label expands naturally */
}

.snapshot-section li span {
  color: #64748b;
}

.snapshot-section li strong {
  color: #0f172a;
  font-weight: 600;
}

.snapshot-footer {
  border-top: 1px solid #e2e8f0;
  padding-top: 10px;
  margin-top: 10px;
  font-size: 0.9rem;
  color: #64748b;
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.snapshot-footer strong {
  color: #0f172a;
}

.snapshot-note {
  font-style: italic;
}

/* Icon beside each metric */
.signal {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  margin-right: 6px;
  font-size: 0.8rem;
  font-weight: 700;
}

.signal.positive {
  color: #16a34a; /* green-600 */
}

.signal.negative {
  color: #dc2626; /* red-600 */
}

.metadata-container {
  max-height: 70vh;
  overflow-y: auto;
  padding: 1rem;
  background: var(--secondary-ui-colour);
  border-radius: 6px;
  border: 1px solid var(--outline-colour);
}

.metadata-pretty {
  white-space: pre-wrap;
  word-break: break-word;
  font-family: ui-monospace, SFMono-Regular, Menlo, monospace;
  font-size: 0.85rem;
  margin: 0;
  color: var(--text-colour);
}
</style>
